module.exports = __webpack_public_path__ + "img/0726_V0B.063bda0c.jpg";